'use strict'

import ReportDebitsGroup from './ReportDebitsGroup.js'
import ReportDemountingsGroup from './ReportDemountingsGroup.js'
import ReportMountingsGroup from './ReportMountingsGroup.js'
import ReportConsumptionsGroup from './ReportConsumptionsGroup.js'

export default class ReportMaterialsGroups {
  constructor (report) {
    this.report = report

    this.groups = {
      demountings: new ReportDemountingsGroup({
        key: 'demountings',
        name: 'Демонтаж',
        consumingType: 'demounting',
        report
      }),
      mountings: new ReportMountingsGroup({
        key: 'mountings',
        name: 'Монтаж',
        consumingType: 'mounting',
        report
      }),
      debits: new ReportDebitsGroup({
        key: 'debits',
        name: 'Списания',
        consumingType: 'debit',
        report
      }),
      consumptions: new ReportConsumptionsGroup({
        key: 'consumptions',
        name: 'Расход вне склада',
        consumingType: 'consumption',
        report
      })
    }
  }

  getGroup (groupKey) {
    return this.groups[groupKey]
  }

  hasChanges () {
    return Object.values(this.groups).find(materialsGroup => materialsGroup.hasChanges()) != null
  }

  applyChanges (properties) {
    Object.values(this.groups).forEach(materialsGroup => {
      materialsGroup.applyChanges(properties)
    })
  }
}
